"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cache = void 0;

var _reactVirtualized = require("react-virtualized");

var cache = new _reactVirtualized.CellMeasurerCache({
  minHeight: 45,
  defaultWidth: 300,
  fixedWidth: true
});
exports.cache = cache;